/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TenantOut
 */
export interface TenantOut {
    /**
     * 
     * @type {number}
     * @memberof TenantOut
     */
    id: number;
}

export function TenantOutFromJSON(json: any): TenantOut {
    return TenantOutFromJSONTyped(json, false);
}

export function TenantOutFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantOut {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function TenantOutToJSON(value?: TenantOut | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


